import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Axios from "../../utilities/Axios";

export default function RegisteredCourseDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedCourse = location.state || {};
  
  const [loading, setLoading] = useState(false);
  const [lessonsData, setLessonsData] = useState([]);
  const [currentContent, setCurrentContent] = useState({ url: "", title: "", type: "video" });
  const [collapsed, setCollapsed] = useState({});

  useEffect(() => {
    getCoursesLessons(selectedCourse.id);
  }, [selectedCourse.id]);

  const getCoursesLessons = async (id) => {
    try {
      setLoading(true);
      const userId = localStorage.getItem("uid") || "0";
      const response = await Axios.post("courses/get_lessons_for_user", {
        user_id: userId,
        course_id: id
      });
      const data = JSON.parse(response.data.data[0].contents);
      setLessonsData(data);
      
      setCurrentContent({ 
        url: data[0]?.video_link, 
        title: data[0]?.title,
        type: "video"
      });
      setCollapsed(data.reduce((acc, item) => ({
        ...acc,
        [item.id]: true
      }), {}));
    } catch (error) {
      console.error("Error fetching lessons:", error);
    } finally {
      setLoading(false);
    }
  };

  const toggleCollapse = (chapterId) => {
    setCollapsed(prev => ({ ...prev, [chapterId]: !prev[chapterId] }));
  };

  const handleContentClick = (url, title, type) => {
    setCurrentContent({ url, title, type });
  };

  const getIframeSrc = () => {
    // if (currentContent.type === "pdf") {
    //   // return `https://docs.google.com/viewer?url=${encodeURIComponent(currentContent.url)}&embedded=true`;
    //   return currentContent.url + '#toolbar=0';
    // }
    return currentContent.url;
  };

  return (
    <div className="bg-white p-3 rounded shadow-sm">
      {/* {loading && <div>Loading...</div>} */}
      <div className="row">
        <div className="col-md-4">
          <div className="card p-3 mb-2 shadow-sm" style={{ border: "1px solid #dee2e6" }}>
            <h5 className="mt-2 text-center">{selectedCourse.name}</h5>
            {/* <div style={{ fontSize: "0.75rem", color: "#6c757d" }}>
              
              <div style={{ marginTop: "5px" }}>
                <div>📚 Lessons: {selectedCourse.lessons}</div>
                <div>📖 Type: {selectedCourse.type}</div>
                <div>⌛ Duration: {selectedCourse.duration?.charAt(0).toUpperCase() + selectedCourse.duration?.slice(1)}</div>
                <div>📅 Start Date: {selectedCourse.start_date}</div>
              </div>
            </div> */}
          </div>

          <div className="p-3 rounded shadow-sm" style={{ backgroundColor: "#f8f9fa" }}>
            <h6 className="mb-3">Lessons</h6>
            {lessonsData.map((item, index) => (
              <div key={item.id} className="chapter-container">
                <div
                  className="d-flex justify-content-between align-items-center p-2 mb-2 rounded"
                  style={{
                    cursor: "pointer",
                    backgroundColor: currentContent.title === item.title ? "#fff6e5" : "#ffffff",
                    border: currentContent.title === item.title ? "1px solid #fe880e" : "1px solid #dee2e6",
                    transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
                    boxShadow: currentContent.title === item.title ? "0px 4px 8px rgba(0, 0, 0, 0.1)" : "none"
                  }}
                  onClick={() => {
                    handleContentClick(item.video_link, item.title, "video");
                    toggleCollapse(item.id);
                  }}
                  onMouseDown={e => e.currentTarget.style.transform = "scale(0.98)"}
                  onMouseUp={e => e.currentTarget.style.transform = "scale(1)"}
                  onMouseEnter={e => e.currentTarget.style.transform = "scale(1.02)"}
                  onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
                >
                  <div className="d-flex align-items-center">
                    <span style={{ color: currentContent.title === item.title ? "#fe880e" : "#000", marginRight: "8px" }}>▶</span>
                    <span style={{ fontSize: "16px", fontWeight: "500" }}>
                      {item.title}
                    </span>
                  </div>
                </div>

                {!collapsed[item.id] && item.contents && (
                  <div className="ml-4">
                    {item.contents.map(content => (
                      <div
                        key={content.id}
                        className="d-flex align-items-center p-2 mb-2 rounded"
                        style={{
                          cursor: "pointer",
                          backgroundColor: currentContent.url === content.url ? "#f0f8ff" : "#ffffff",
                          border: currentContent.url === content.url ? "1px solid #007bff" : "1px solid #dee2e6"
                        }}
                        onClick={() => handleContentClick(content.url, content.title, content.type)}
                      >
                        <span style={{ marginLeft: "25px", fontSize: "14px" }}>
                          {content.type === "pdf" ? "📄" : "🎬"} {content.title}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="col-md-8">
          <div style={{
            fontSize: "1rem",
            fontWeight: "bold",
            marginBottom: "8px",
            textAlign: "center",
            padding: "6px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            border: "1px solid #dee2e6"
          }}>
            {currentContent.type === "pdf" ? "📄 Document:" : "🎬 Now Playing:"} {currentContent.title}
          </div>
          <iframe
            src={getIframeSrc()}
            className="w-100 rounded shadow-sm"
            style={{ height: "490px", border: "none" }}
            title={currentContent.type === "pdf" ? "PDF Viewer" : "Course Video"}
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
}